module.exports = __webpack_public_path__ + "static/media/athletes-icon.aa23f36a.svg";